import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import styles from "@/styles/ContentHeader.module.scss";
import classnames from "classnames";
var IconArrow = function IconArrow(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("g", {
      transform: "translate(0.813 0.813)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M.6.6l6,6.5,6-6.5",
        fill: "none",
        stroke: "#e6e6e6",
        strokeLinecap: "round",
        strokeWidth: "2"
      })
    })
  }));
};
IconArrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14.826",
  height: "9.387",
  viewBox: "0 0 14.826 9.387"
};
import VersatileLink from "@/components/VersatileLink";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ContentHeader(_ref) {
  let {
    text,
    link,
    viewTypeClassName,
    main
  } = _ref;
  const classNames = classnames(styles.header, {
    [styles.grid]: viewTypeClassName === "grid",
    [styles.list]: viewTypeClassName === "list",
    [styles.channelList]: viewTypeClassName === "channelList",
    [styles.pickuplist]: viewTypeClassName === "pickuplist",
    [styles.genrePalette]: viewTypeClassName === "genrePalette"
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [main && /*#__PURE__*/_jsx("h1", {
      className: classNames,
      children: /*#__PURE__*/_jsx(Content, {
        text: text,
        link: link
      })
    }), !main && /*#__PURE__*/_jsx("h2", {
      className: classNames,
      children: /*#__PURE__*/_jsx(Content, {
        text: text,
        link: link
      })
    })]
  });
}
function Content(_ref2) {
  let {
    text,
    link
  } = _ref2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [link && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(VersatileLink, {
        href: link.href,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.title,
          children: text
        })
      }), /*#__PURE__*/_jsx(VersatileLink, {
        href: link.href,
        children: /*#__PURE__*/_jsx("a", {
          className: styles.more,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.caret,
            children: ["\u3082\u3063\u3068\u898B\u308B", /*#__PURE__*/_jsx(IconArrow, {})]
          })
        })
      })]
    }), !link && /*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: text
    })]
  });
}